import { Text, Container, Link, Icon } from "@simplybusiness/mobius";
import { leftArrow } from "@simplybusiness/icons";
import { useSnowplowContext } from "@simplybusiness/services";
import type { QuoteHeadlineWithBacklinkProps } from "./types";

export const QuoteHeadlineWithBacklink = ({
  quoteCount,
  product,
  backLinkUrl,
  journeyId,
  vertical,
}: QuoteHeadlineWithBacklinkProps) => {
  const { snowplow } = useSnowplowContext();

  if (quoteCount === 0) {
    return null;
  }

  const handleBackLinkClick = () => {
    if (journeyId && vertical) {
      snowplow?.trigger("backToApplication", { journeyId, vertical });
    }
  };

  return (
    <Container size="sm">
      {backLinkUrl && (
        <Link
          href={backLinkUrl}
          className="mobius-quote-headline__link"
          onClick={handleBackLinkClick}
        >
          <Icon
            icon={leftArrow}
            size="xs"
            className="mobius-quote-headline__back-icon"
            title="Return to previous step"
          />
          <span>Back</span>
        </Link>
      )}
      <Text className="mobius-quote-headline__title">
        Your <strong>{product}</strong> quotes
      </Text>
      <Text className="mobius-quote-headline__description">
        We searched through multiple carriers and found{" "}
        <strong>
          {quoteCount} quote{quoteCount > 1 ? "s" : ""}{" "}
        </strong>
        for your business
      </Text>
    </Container>
  );
};
